import React from "react";
import LocalBarIcon from "@mui/icons-material/LocalBar";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import SettingsIcon from "@mui/icons-material/Settings";
import LoginIcon from "@mui/icons-material/Login";
import TuneIcon from "@mui/icons-material/Tune";
import StarIcon from "@mui/icons-material/Star";

import { getLanguage } from "../language/language";

export const PAGE_VERSION = "v0.1.3";
export const INDEX_PATH = "";
export const PAGE_ENABLE_LOADER = true;
export const PAGE_LOADING_MS = 800;

export const HTTP_QUERY_TIMEOUT_MS = 90000;

export const AUTO_OPEN_SIDEBAR_PX = 1200;
export const HIDE_TOOLBAR_DESCRIPTION_PX = 1015;
export const PAGE_DRAWER_WIDTH_PX = 275;
export const ELEMENT_MIN_WIDTH_PX = 285;
export const SIDEBAR_TEXT_MIN_WIDTH = 24;

export const DEVELOPMENT_ENV = ["localhost", "127.0.0.1"].includes(window.location.hostname) && window.location.port === "3000";

const DEFAULT_SERVER_IP = window.location.protocol + "//" + window.location.hostname;
const DEFAULT_SERVER_PORT = DEVELOPMENT_ENV ? ":8080" : "";

const RUNTIME_ENV = typeof window !== "undefined" && window._env_ ? window._env_ : {};

export const SERVER_IP = DEVELOPMENT_ENV ? DEFAULT_SERVER_IP : RUNTIME_ENV.SERVER_IP || DEFAULT_SERVER_IP;
export const SERVER_PORT = DEVELOPMENT_ENV ? DEFAULT_SERVER_PORT : RUNTIME_ENV.SERVER_PORT || DEFAULT_SERVER_PORT;

export const API_PROGRAM_STATUS = "/api/status";
export const API_AUTH_STATUS = "/api/auth/status";
export const API_LOGIN_PATH = "/api/auth/login";
export const API_MENU = "/api/menu";
export const API_ADMIN_MENU_REFRESH = "/api/admin/menu/refresh";
export const API_ADMIN_MENU_EXPORT = "/api/admin/menu/export";
export const API_CHAT = "/api/chat";
export const API_CHAT_STREAM = "/api/chat/stream";
export const API_ADMIN_SETTINGS = "/api/admin/settings";
export const API_IMAGES_IMPORT_EXPORT = "/api/images/import-export";
export const API_IMAGES_IMPORT_FOLDER = "/api/images/import-folder";

/** Build nav items from the active language pack (call at render time). */
export const getNavItems = () => {
    const LANG = getLanguage();
    return [
        {
            name: LANG.SIDEBAR_MENU,
            description: LANG.SIDEBAR_MENU_TOOLTIP,
            icon: <LocalBarIcon />,
            path: "/"
        },
        {
            name: LANG.SIDEBAR_CHAT,
            description: LANG.SIDEBAR_CHAT_TOOLTIP,
            icon: <AutoAwesomeIcon />,
            path: "/chat"
        },
        {
            name: LANG.SIDEBAR_FAVORITES,
            description: LANG.SIDEBAR_FAVORITES_TOOLTIP,
            icon: <StarIcon />,
            path: "/favorites"
        },
        {
            name: LANG.SIDEBAR_PREFS,
            description: LANG.SIDEBAR_PREFS_TOOLTIP,
            icon: <TuneIcon />,
            path: "/preferences"
        },
        {
            name: LANG.SIDEBAR_ADMIN,
            description: LANG.SIDEBAR_ADMIN_TOOLTIP,
            icon: <SettingsIcon />,
            path: "/admin",
            adminOnly: true
        },
        {
            name: LANG.SIDEBAR_LOGIN,
            description: LANG.SIDEBAR_LOGIN_TOOLTIP,
            icon: <LoginIcon />,
            path: "/login",
            guestOnly: true
        }
    ];
};
